// ** React Imports
import { type ReactNode } from 'react'

// ** Component Imports
import { Typography } from '@/shared/ui'

// ** Third Party Imports
import * as RadixTooltip from '@radix-ui/react-tooltip'

// ** Styled Components
import { TooltipArrow, TooltipContent, TooltipTrigger } from './styles'

interface IProps {
	offset?: number
	content: string
	children: ReactNode
	side?: 'top' | 'bottom' | 'left' | 'right'
	align?: 'start' | 'center' | 'end'
	style?: React.CSSProperties
}

export const Tooltip = ({ offset, content, children, side = 'top', align = 'center', style }: IProps) => {
	return (
		<RadixTooltip.Provider delayDuration={0}>
			<RadixTooltip.Root>
				<TooltipTrigger asChild>{children}</TooltipTrigger>
				<RadixTooltip.Portal>
					<TooltipContent sideOffset={offset ?? 0} side={side} align={align} style={style}>
						<Typography variant='body3' weight='semi-bold'>
							{content}
						</Typography>
						<TooltipArrow />
					</TooltipContent>
				</RadixTooltip.Portal>
			</RadixTooltip.Root>
		</RadixTooltip.Provider>
	)
}
